import(/* webpackMode: "eager" */ "/vercel/path0/app/_lib/assets/images/bg-lined.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
